export default "__VITE_PUBLIC_ASSET__35e21fb3__"